module.exports = __webpack_public_path__ + "img/icon-search.7e061ad3.svg";